import mixpanel from 'mixpanel-browser';
import { all, takeEvery } from 'redux-saga/effects';


export function initMixpanelTracking(api, action) {
    const { config } = action.getState();
    const token = config.env.REACT_APP_MIXPANEL_TOKEN || '5ad24aefc6da32d737bb77387527743d';

    return mixpanel.init(token, {
        debug: config.isDevelopment
    });
}

export function initSegmentTracking(api, action) {
    const { config } = action.getState();
    const segmentToken = config.env.REACT_APP_SEGMENT_TOKEN;
    const analytics = window && window.analytics;
    return analytics && analytics.load(segmentToken);
}

export default function* trackingSaga({ api }) {
    yield all([
        // Mixpanel disabled 2/2
        // takeEvery('@@INIT-SAGAS', initMixpanelTracking, api),
        takeEvery('@@INIT-SAGAS', initSegmentTracking, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/tracking/saga.js